import { initializeApp } from "firebase/app";
import { getDatabase, ref } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyBi-eyZ_lgBCThFo6OtchYrtyJm1qdrtDQ",
    authDomain: "ceylonmuslim-bb7b7.firebaseapp.com",
    projectId: "ceylonmuslim-bb7b7",
    storageBucket: "ceylonmuslim-bb7b7.firebasestorage.app",
    messagingSenderId: "375920908149",
    appId: "1:375920908149:web:a97e57488f65c247ce653c",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export { ref };     